export default __webpack_public_path__ + "static/media/rejected.eb3dee4c.svg";